import React from 'react';
import { MaskedRange } from 'imask';
import { AdapterProps } from '../types';
import MaskedTextAdapter from './MaskedTextAdapter';

export type Props = AdapterProps['time'];

/** IMask blocks: hours 00-23, minutes 00-59 (invalid digits are not accepted). */
const TIME_IMASK_OPTIONS = {
  mask: 'HH:MM',
  blocks: {
    HH: {
      mask: MaskedRange,
      from: 0,
      to: 23,
      maxLength: 2,
    },
    MM: {
      mask: MaskedRange,
      from: 0,
      to: 59,
      maxLength: 2,
    },
  },
  lazy: false,
};

const TimeAdapter = (props: Props) => (
  <MaskedTextAdapter
    {...props}
    imaskOptions={TIME_IMASK_OPTIONS}
    placeholderChar={props.placeholderChar ?? '0'}
  />
);

export default TimeAdapter;
